


























import Vue from 'vue'
import Component from 'vue-class-component'
import CircleChart from '@/components/chart/CircleChart.vue'

@Component({
  components: {
    CircleChart
  },
  props: {
    title: {
      required: true,
      type: String
    },
    type: {
      type: String,
      default: 'full'
    },
    total: {
      required: true,
      type: String
    },
    size: {
      required: true,
      type: Number
    },
    data: {
      required: true,
      type: Array
    }
  }
})
export default class CircleChartWithDescriptions extends Vue {

}
